import { render, staticRenderFns } from "./Intention.vue?vue&type=template&id=21152832&scoped=true&"
import script from "./Intention.vue?vue&type=script&lang=js&"
export * from "./Intention.vue?vue&type=script&lang=js&"
import style0 from "./Intention.vue?vue&type=style&index=0&id=21152832&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21152832",
  null
  
)

export default component.exports